import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { 
  AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, FestivalUserService 
} from 'src/core/services';
import { FestivalUser, DocumentReference } from '../../core/models';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';
import { TextService } from 'src/core/services/text-service';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-migrate-users',
  templateUrl: './migrate-users.component.html',
  styleUrls: ['./migrate-users.component.less', '../../core/styles/common.less']
})

export class MigrateUsersComponent extends PageClass implements OnInit {

  churchList: DocumentReference[];
  festivalUserList: FestivalUser[] = [];

  isLoading = true;

  filter: any = { filterChurch: undefined };

  migration: {
    serviceYear: string;
    resetPermissions: boolean;
    result: string;
  } = {
    serviceYear: environment.migrateFrom,
    resetPermissions: false,
    result: ''
  }

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private router: Router,
    protected festivalUserService: FestivalUserService,
    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController,
    private textService: TextService
  ) {
      super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (!this.currentUser.isAdmin) {
        this.router.navigate(['/']);
      } else {
        this.filter = {};

        this.migration = {
          serviceYear: environment.migrateFrom,
          resetPermissions: true,
          result: ''
        };

        this.filter.filterChurch = localStorage.getItem('filteredChurch') ? 
        this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch')) : 
        this.churchList[0];

        await this.getFestivalUserList();
      }
    }
  }

  public getFestivalUserList() {
    // Save Filters
    localStorage.setItem('filteredChurch', this.filter.filterChurch.reference.id);

    this.festivalUserService.getFestivalUserList(true, false, this.filter.filterChurch, environment.serviceYear, true)
      .subscribe(festivalUserList => {
        this.festivalUserList = festivalUserList.sort(this.festivalUserService.orderByUserName);
        this.isLoading = false;
      });
  }
  
  public migrateServants() {
    this.appendMigrationResult('Starting migration', true);
    const serviceYear = this.migration.serviceYear;
    const resetPermissions = this.migration.resetPermissions;

    this.festivalUserService.getFestivalUserList(true, false, this.filter.filterChurch, serviceYear, true)
      .pipe(take(1))
      .subscribe((serviceYearUsers: FestivalUser[]) => {
        this.migrateServiceYearUsers(serviceYearUsers, resetPermissions);
      });
  }

  public migratePriests() {
    this.appendMigrationResult('Starting migration', true);
    const serviceYear = this.migration.serviceYear;
    const resetPermissions = this.migration.resetPermissions;

    this.festivalUserService.getPriests(true, false, serviceYear)
      .pipe(take(1))
      .subscribe((serviceYearUsers: FestivalUser[]) => {
        this.migrateServiceYearUsers(serviceYearUsers, resetPermissions);
      });
  }

  private migrateServiceYearUsers(serviceYearUsers: FestivalUser[], resetPermissions: boolean) {
    this.appendMigrationResult(`Found ${serviceYearUsers.length} users`)
    serviceYearUsers.forEach((serviceYearUser: FestivalUser) => {

      serviceYearUser = {
        ...serviceYearUser,
        email: this.textService.toLowerCase(serviceYearUser.email),
        user: {
          reference: serviceYearUser.user.reference,
          displayName: this.textService.toPascalCase(serviceYearUser.user.displayName)
        }
      };

      this.festivalUserService.migrateFestivalUser(serviceYearUser, resetPermissions, this.ageLevelList).then(() => {
        this.appendMigrationResult(`Migrated user ${serviceYearUser.user.displayName} - ${serviceYearUser.email}`);
      });
    });
  }

  private appendMigrationResult(message: string, reset: boolean = false): void {
    if (reset)
      this.migration.result = `${message}\r\n`;
    else  
      this.migration.result += `${message}\r\n`
  }

}